//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Button from "~/components/other/Button";

export default {
  components: {
    Button
  },
  data() {
    return {
      hidden: false,
      observer: null,
    }
  },
  mounted() {
    const options = {
      rootMargin: `50px`,
    }

    this.observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.hidden = true
        } else {
          this.hidden = false
        }
      })
    }, options)

    this.observer.observe(document.querySelector('footer'))
  },
  beforeDestroy () {
    this.observer.unobserve(document.querySelector('footer'))
  }
}
